import React from 'react';
import PublicPage from '../cms/PublicPage';

export default function AdmissionsPage() {
  return <PublicPage slug="admissions" />;
}
